export type Breakpoint =
  | '_'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | '2xl'
  | 'md-lg'
  | 'sm-md'

export type IBreakpoints = Record<Breakpoint, number>

const breakpoints: IBreakpoints = {
  _: 0,
  xs: 0,
  sm: 480,
  'sm-md': 640,
  md: 768,
  'md-lg': 920,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
}

export default breakpoints

function getBreakpoint(breakpoint: Breakpoint | number): number {
  if (typeof breakpoint === 'number') {
    return breakpoint
  }

  return breakpoints[breakpoint]
}

export function mediaBreakpointUp(breakpoint: Breakpoint | number): string {
  return `@media (min-width: ${getBreakpoint(breakpoint)}px)`
}

export function mediaBreakpointDown(
  breakpoint: Exclude<Breakpoint, '_' | 'xs'> | number
): string {
  return `@media (max-width: ${getBreakpoint(breakpoint) - 0.02}px)`
}
